import { GLSectionCategoryLinkContainerModel } from './../../../../../../models/aggregates/erp/gl-section/gl-section-category-link-container.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';




@Injectable({
  providedIn: 'root'
})
export class GLSectionCatgeoryLinkService extends BaseApiTemplateService<GLSectionCategoryLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'report-section-gl-category-links';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'report-section-gl-category-links';
    this.httpClient = http;
  }
}
